<template>
  <div name="staapprCount-button">
    <template v-if="disable">
      <div class="sta-disable">
        <div v-if="staappr === 'P'" class="sta-disable text-gray"><i class="fa fa-circle-o-notch icon-status"></i>Pending</div>
        <div v-if="staappr === 'A'" class="sta-disable text-blue"><i class="fa fa-check icon-status"></i>Approving</div>
        <div v-if="staappr === 'Y'" class="sta-disable text-green"><i class="fa fa-check-circle icon-status"></i>Approved</div>
        <div v-if="staappr === 'C'" class="sta-disable text-gray-dark"><i class="fa fa-close icon-status"></i>Canceled</div>
        <div v-if="staappr === 'N'" class="sta-disable text-red"><i class="fa fa-ban icon-status"></i>Rejected</div>
      </div>
    </template>
    <template v-else>
      <div @click="countStaappr()" :class="[ flgStaapprCount == 0 ? 'sta-none' : flgStaapprCount == 1 ? 'sta-approve' : 'sta-reject' ]" class="cursor-pointer">
        <i :class="'fa fa-' + [ flgStaapprCount == 0 ? 'circle-o-notch' : flgStaapprCount == 1 ? 'check-circle' : 'ban' ]" class="icon-status"></i>{{status}}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'staapprCount-button',
  data () {
    return {
      flgStaappr: this.value,
      flgStaapprCount: 0,
      status: 'None'
    }
  },
  watch: {
    value (newVal) {
      this.flgStaappr = newVal.trim()
      switch (this.flgStaappr) {
        case '':
          this.flgStaapprCount = 0
          this.status = 'None'
          break
        case 'A':
          this.flgStaapprCount = 1
          this.status = 'Approve'
          break
        case 'N':
          this.flgStaapprCount = 2
          this.status = 'Reject'
          break
        default:
          this.flgStaapprCount = 0
          this.status = 'None'
          break
      }
      this.$emit('input', this.flgStaappr)
    }
  },
  props: {
    value: {
      type: String
    },
    staappr: {
      type: String
    },
    approveRowBool: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    countStaappr () {
      if (this.approveRowBool) {
        this.$emit('setDefaultStatus')
      }
      this.flgStaapprCount++
      if (this.flgStaapprCount > 2) {
        this.flgStaapprCount = 0
      }
      switch (this.flgStaapprCount) {
        case 0:
          this.flgStaappr = ''
          this.status = 'None'
          break
        case 1:
          this.flgStaappr = 'A'
          this.status = 'Approve'
          break
        case 2:
          this.flgStaappr = 'N'
          this.status = 'Reject'
          break
      }
      this.$emit('input', this.flgStaappr)
    }
  }
}
</script>

<style>
.icon-status{
  margin:0 5px 0 0;
}
.sta-disable {
  font-size: 11px;
  text-align: center;
  font-style: italic;
}
.sta-none {
  transition: background 0.3s ease;
  background:#e4e0e0;
  text-align: center;
  border-radius: 2px;
  line-height: 37px;
  height: 35px;
  width: 80px;
  margin:0 auto;
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.2);
  color:#666;
  font-weight:700;
  font-size:12px;
}
.sta-approve {
  transition: background 0.3s ease;
  background:#66BB6A;
  text-align: center;
  border-radius: 2px;
  line-height: 37px;
  height: 35px;
  width: 80px;
  margin:0 auto;
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.2);
  color:#FFF;
  font-size:12px;
}
.sta-reject {
  transition: background 0.3s ease;
  background:#EF5350;
  text-align: center;
  border-radius: 2px;
  line-height: 37px;
  height: 35px;
  width: 80px;
  margin:0 auto;
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.2);
  color:#FFF;
  font-size:12px;
}
</style>


// WEBPACK FOOTER //
// staapprButton.vue?63358fec